import { useState } from "react";
import { ImageUpload } from "./ImageUpload";
import { Field, Toggle, numOrNull } from "./Field";

export const PackageForm = ({ initial, onSubmit, busy }) => {
  const [f, setF] = useState({ name: "", tag: "", image: "", perks: [], price_from: null, link: "", featured: false, active: true, sort_order: 0, ...initial });
  const [perks, setPerks] = useState((initial?.perks || []).join("\n"));
  const set = (k) => (e) => setF({ ...f, [k]: e?.target ? e.target.value : e });
  const submit = (e) => {
    e.preventDefault();
    onSubmit({ ...f, price_from: numOrNull(f.price_from), sort_order: Number(f.sort_order) || 0, perks: perks.split("\n").map((p) => p.trim()).filter(Boolean) });
  };
  return (
    <form onSubmit={submit} className="grid gap-4 sm:grid-cols-2" data-testid="package-form">
      <Field label="Package name *"><input required data-testid="pf-name" className="admin-input" value={f.name} onChange={set("name")} /></Field>
      <Field label="Tag"><input data-testid="pf-tag" className="admin-input" value={f.tag} onChange={set("tag")} placeholder="Most Popular" /></Field>
      <div className="sm:col-span-2"><ImageUpload value={f.image} onChange={set("image")} testId="pf-image" /></div>
      <Field label="What's included (one per line)" className="sm:col-span-2"><textarea rows={4} data-testid="pf-perks" className="admin-input" value={perks} onChange={(e) => setPerks(e.target.value)} /></Field>
      <Field label="Price from (CAD) — blank = coming soon"><input type="number" min="0" data-testid="pf-price" className="admin-input" value={f.price_from ?? ""} onChange={set("price_from")} /></Field>
      <Field label="Booking link (optional)"><input type="url" data-testid="pf-link" className="admin-input" value={f.link} onChange={set("link")} placeholder="https://" /></Field>
      <Field label="Display order"><input type="number" data-testid="pf-order" className="admin-input" value={f.sort_order} onChange={set("sort_order")} /></Field>
      <div className="flex flex-col justify-end gap-3">
        <Toggle label="Featured" checked={f.featured} onChange={set("featured")} testId="pf-featured" />
        <Toggle label="Visible on website" checked={f.active} onChange={set("active")} testId="pf-active" />
      </div>
      <button data-testid="pf-submit" disabled={busy} className="btn-primary justify-center sm:col-span-2">{busy ? "Saving…" : "Save Package"}</button>
    </form>
  );
};
